import v1 from '@/assets/verify/v1.png';
import v2 from '@/assets/verify/v2.png';
import v3 from '@/assets/verify/v3.png';
import v4 from '@/assets/verify/v4.png';
import v5 from '@/assets/verify/v5.png';
import v6 from '@/assets/verify/v6.png';
import v7 from '@/assets/verify/v7.png';
const imgs = [v1, v2, v3, v4, v5, v6, v7];
export default imgs;
